import { tokensOf } from "@/model/tokens";
import { type Exporter, GENERATED_BY } from "./types";

export const herdr: Exporter = {
  id: "herdr",
  label: "herdr",
  app: true,
  description: "[theme] table with every [theme.custom] color token.",
  run: (ctx) => {
    const { color, theme, appName } = ctx;
    const tokens = tokensOf("herdr");
    const width = Math.max(...tokens.map((t) => t.key.length));
    const lines = [
      `# ${appName}: "${theme.name}" (${theme.variant}), ${GENERATED_BY}`,
      "[theme]",
      '# Base theme for anything not covered below: "terminal" follows the',
      "# host terminal's ANSI palette (the matching Ghostty theme).",
      'name = "terminal"',
      "",
      "[theme.custom]",
      ...tokens.map((t) => `${t.key.padEnd(width)} = "${color(t.id)}"`),
    ];
    return {
      files: [
        {
          path: "~/.config/herdr/config.toml",
          filename: `${appName}.herdr.toml`,
          language: "toml",
          content: `${lines.join("\n")}\n`,
        },
      ],
      steps: [
        "Open `~/.config/herdr/config.toml`.",
        "Replace the existing `[theme]` table, and any `[theme.custom]`, `[theme.custom.dark]` or `[theme.custom.light]` tables, with the snippet below. Keep every other table and key exactly as it is.",
        "Apply it without restarting: `herdr server reload-config`.",
      ],
      verify: ["herdr config check"],
      notes: [
        "Tokens accepted by herdr 0.9.x. If `herdr config check` reports an unknown key on an older version, delete that line.",
      ],
    };
  },
};
